import { useConsent } from '@shared/contexts/ConsentContext'
import { usePWA } from '@shared/contexts/PWAContext'
import { useTourLifecycle } from '@shared/contexts/TourLifecycleContext'

export function useCanStartTour() {
  const { decision } = useConsent()
  const { isPromptVisible } = usePWA()
  const { isTourActive } = useTourLifecycle()

  return decision !== null && !isPromptVisible && !isTourActive
}
